module.exports = __webpack_public_path__ + "static/media/cancel.23de501e.png";